import {useEffect, useMemo} from 'react'
import {useParams} from 'react-router-dom'
import {DataLrItem} from '../core/_models'
import {CustomRow} from './columns/CustomRow'
import {LrColumns} from './columns/_columns'
import {LrChart} from '../components/LrChart'
import {useAppSelector} from '../../../hooks/redux'
import {csrAPI} from '../../../services/CSRService'
import {KTCardBody} from '../../../template/helpers'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {TableLoading} from '../../../template/helpers/TableLoading'
import {useAccount} from '../../../hooks/useAccount'

const LrTable = () => {
  const {appId} = useParams()
  const query = useAppSelector((state) => state.lrFilter)
  const {currentAccountIdForRequest: accountId} = useAccount()
  const [fetch, {data, isLoading}] = csrAPI.useLinesFetchReportMutation()

  useEffect(() => {
    fetch({id: appId!, filter: {...query}, account_id: accountId})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, accountId])

  const dataItems = data ? (data?.lines as DataLrItem[]) : []

  const columns = useMemo(() => LrColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data: dataItems,
  })

  const total = data?.total_lines
  const totalInbound = dataItems.reduce((sum, i) => sum + i.incoming_count, 0)
  const totalMissed = dataItems.reduce((sum, i) => sum + i.missed_count, 0)
  const totalUniqueInbound = dataItems.reduce((sum, i) => sum + i.incoming_unique_count, 0)
  const totalUniqueMissed = dataItems.reduce((sum, i) => sum + i.missed_unique_count, 0)

  return (
    <KTCardBody className='pt-1 pb-4'>
      {isLoading && <TableLoading />}
      <LrChart items={dataItems} />
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<DataLrItem>, i) => (
                <CustomHeaderColumn key={i} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 && (
              <tr>
                <td>
                  <div className='d-flex align-content-center text-warning'>линии {total}</div>
                </td>
                <td>
                  <div className='d-flex align-content-center text-primary'>{totalInbound}</div>
                </td>
                <td>
                  <div className='d-flex align-content-center text-danger'>{totalMissed}</div>
                </td>
                <td>
                  <div className='d-flex align-content-center text-primary'>{totalUniqueInbound}</div>
                </td>
                <td>
                  <div className='d-flex align-content-center text-danger'>{totalUniqueMissed}</div>
                </td>
              </tr>
            )}
            {rows.length > 0 ? (
              rows.map((row: Row<DataLrItem>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>---</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </KTCardBody>
  )
}

export {LrTable}
